import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { SHOW_TICKETING_ERROR_POPUP } from '@/lib/config';
import movieClubLogo from '@/assets/movie-club-logo.png';

const STORAGE_KEY = 'ticketing-error-popup-dismissed';

function getTodayString() {
  return new Date().toISOString().slice(0, 10);
}

function shouldForceShow() {
  const params = new URLSearchParams(window.location.search);
  return params.get('showTicketingError') === 'true';
}

export default function TicketingErrorPopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!SHOW_TICKETING_ERROR_POPUP) return;

    if (shouldForceShow()) {
      setOpen(true);
      return;
    }

    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (dismissed !== getTodayString()) {
      setOpen(true);
    }
  }, []);

  if (!SHOW_TICKETING_ERROR_POPUP) return null;

  function handleOpenChange(value: boolean) {
    if (!value) {
      localStorage.setItem(STORAGE_KEY, getTodayString());
    }
    setOpen(value);
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-lg border-none bg-[#F02C7E] text-white [&>button]:text-white">
        <DialogTitle className="sr-only">Aviso de sistema</DialogTitle>
        <div className="space-y-6 text-center">
          <p className="text-lg font-bold text-[#fbed20]">Estimado cliente:</p>
          <p>
            En este momento estamos presentando inconvenientes con el sistema de ventas. Te pedimos que intentes
            realizar tu reserva más tarde.
          </p>
          <p>Estamos trabajando para solucionarlo a la brevedad.</p>
          <img src={movieClubLogo} alt="Movie Club" className="mx-auto w-48" />
        </div>
      </DialogContent>
    </Dialog>
  );
}
